import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import { fetchMissionById } from '../../services/pmissions.service';
import { teacherFetchStudentMissions } from '../../services/pstudentMissions.service';
import SchoolStatistic from '../primary_admin/components/SchoolStatistic';

function Component(props) {
    const { id,schoolId } = useParams();
    const navigate = useNavigate();
    let [searchParams, setSearchParams] = useSearchParams();
    const [data, setdata] = useState(null)
    const [isLoading, setisLoading] = useState(false)
    const [total, settotal] = useState(0)
    const [mission, setmission] = useState(null)

    const filter = searchParams.get('filter') || '全部';
    const page = parseInt(searchParams.get('page')) || 1;
    const limit =999
    const totalPage = Math.ceil(total / limit) || 1


    const fetchData = async () => {
        const filter = { missionId:id, status: '已完成' }
        let result = await teacherFetchStudentMissions(props.token.token, filter, { limit, skip: (page - 1) * limit });
        if (result.result) {
            setdata(result?.result)
            settotal(result?.count || 0)
        } else {
            alert('Fetch data error')
        }
    }

    const fetchMissionData = async () => {
        let result = await fetchMissionById(props.token.token, id);
        if (result.result) {
            setmission(result.result)
        } else {
            alert('Fetch data error')
        }
    }

  

    const refresh = async () => {
        setisLoading(true)
        fetchData()
        fetchMissionData()
        setisLoading(false)
    }


    useEffect(() => {
        const timer = setTimeout(refresh, 500)
        // const interval = setInterval(refresh, 1000 * 30)
        return () => {
            clearTimeout(timer)
            // clearInterval(interval)
        }
    }, [searchParams])





    return (
        <SchoolStatistic
            school={null}
            data={data}
            mission={mission}
        />
    );
}

export default connect((store) => {
    return {
        token: store.tokenReducer,
    }
})(Component)
